var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSpecification = function SvgIconSpecification(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1937_91935",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1937_91935)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 21C4.45 21 3.97917 20.8042 3.5875 20.4125C3.19583 20.0209 3 19.55 3 19V5.00003C3 4.45003 3.19583 3.9792 3.5875 3.58753C3.97917 3.19586 4.45 3.00003 5 3.00003H9.2C9.41667 2.40003 9.77917 1.9167 10.2875 1.55003C10.7958 1.18336 11.3667 1.00003 12 1.00003C12.6333 1.00003 13.2042 1.18336 13.7125 1.55003C14.2208 1.9167 14.5833 2.40003 14.8 3.00003H19C19.55 3.00003 20.0208 3.19586 20.4125 3.58753C20.8042 3.9792 21 4.45003 21 5.00003V19C21 19.55 20.8042 20.0209 20.4125 20.4125C20.0208 20.8042 19.55 21 19 21H5ZM7 17H14V15H7V17ZM7 13H17V11H7V13ZM7 9.00003H17V7.00003H7V9.00003ZM12 4.25003C12.2167 4.25003 12.3958 4.1792 12.5375 4.03753C12.6792 3.89586 12.75 3.7167 12.75 3.50003C12.75 3.28336 12.6792 3.1042 12.5375 2.96253C12.3958 2.82086 12.2167 2.75003 12 2.75003C11.7833 2.75003 11.6042 2.82086 11.4625 2.96253C11.3208 3.1042 11.25 3.28336 11.25 3.50003C11.25 3.7167 11.3208 3.89586 11.4625 4.03753C11.6042 4.1792 11.7833 4.25003 12 4.25003Z",
    fill: "#05072C"
  }))));
};
export default SvgIconSpecification;